"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customFootnoteType = exports.footnoteDataType = void 0;
const prop_types_1 = require("prop-types");
exports.footnoteDataType = (0, prop_types_1.shape)({
  meta: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    data: prop_types_1.string.isRequired
  })).isRequired,
  name: prop_types_1.string
});
exports.customFootnoteType = (0, prop_types_1.shape)({
  footnotes: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    data: prop_types_1.string.isRequired,
    name: prop_types_1.string.isRequired
  })),
  name: prop_types_1.string
});